import axios, {AxiosError} from 'axios';
import type {CreateLinkParams, CreateLinkRequest, CreateLinkResponse} from '../../types';

export const CREATE_LINK = '/priceQuotes/createPriceQuoteLink';

type ClientError = Error & {
  clientMessage?: string;
  errorCode?: number;
};

export const createLink = async ({
                                   priceQuoteID,
                                   sentTo,
                                   notes,
                                   password,
                                   passwordHint,
                                 }: CreateLinkParams) => {
  try {
    const data: CreateLinkRequest = {
      priceQuoteID: Number(priceQuoteID),
      sentTo,
      notes,
      password,
      passwordHint,
    };

    const response = await axios.post<CreateLinkResponse>(
      CREATE_LINK,
      data
    );
    const {errorCode} = response.data;

    if (errorCode !== 0) {
      throw new Error();
    }

    return response.data;
  } catch (err) {
    const error = err as AxiosError | ClientError;
    const clientError: ClientError = new Error((error as any)?.message || "Can't create link");
    clientError.clientMessage = "Can't create link";

    throw clientError;
  }
};